(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-brand-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-brand-search-root]');
    roots.forEach((root) => {
      if (root.dataset.brandSearchInitialized === '1') return;
      root.dataset.brandSearchInitialized = '1';

      const input = root.querySelector('[data-brand-search-input]');
      const clearBtn = root.querySelector('[data-brand-search-clear]');
      const items = Array.from(root.querySelectorAll('[data-brand-search-item]'));
      const emptyState = root.querySelector('[data-brand-search-empty]');
      const minChars = parseInt(root.dataset.minChars || '1', 10);

      if (!input) return;

      const normalize = (s) => (s || '').toString().toLowerCase().trim();

      const dispatchEvent = (name, detail) => {
        document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
      };

      let lastKeyword = '';

      const apply = () => {
        const raw = normalize(input.value);
        clearBtn.hidden = raw.length === 0;

        if (raw === lastKeyword) return;
        lastKeyword = raw;

        if (raw.length === 0) {
          items.forEach((el) => (el.hidden = false));
          if (emptyState) emptyState.hidden = true;
          dispatchEvent('brand-search:cleared', {});
          return;
        }

        if (raw.length < minChars) {
          items.forEach((el) => (el.hidden = false));
          if (emptyState) emptyState.hidden = true;
          return;
        }

        let visible = 0;
        items.forEach((el) => {
          const title = el.dataset.productTitle || '';
          const vendor = el.dataset.productVendor || '';
          const tags = el.dataset.productTags || '';
          const haystack = title + ' ' + vendor + ' ' + tags;
          const match = haystack.indexOf(raw) !== -1;
          el.hidden = !match;
          if (match) visible++;
        });

        if (emptyState) emptyState.hidden = visible > 0;

        if (visible > 0) {
          dispatchEvent('brand-search:matched', { keyword: raw, count: visible });
        } else {
          dispatchEvent('brand-search:no-match', { keyword: raw });
        }
      };

      let debounceId = null;
      input.addEventListener('input', () => {
        if (debounceId) clearTimeout(debounceId);
        debounceId = setTimeout(apply, 80);
      });

      clearBtn.addEventListener('click', () => {
        input.value = '';
        input.focus();
        apply();
      });

      input.addEventListener('search', apply);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-more-designs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-explore-more]');
    roots.forEach((root) => {
      if (root.dataset.exploreInitialized === '1') return;
      root.dataset.exploreInitialized = '1';

      const items = Array.from(root.querySelectorAll('[data-explore-item]'));

      if (items.length === 0) {
        return;
      }

      const showFor = (keyword) => {
        let matched = 0;
        items.forEach((el) => {
          const title = el.dataset.collectionTitle || '';
          const isMatch = title.indexOf(keyword) !== -1;
          el.hidden = !isMatch;
          if (isMatch) matched++;
        });

        if (matched > 0) {
          root.hidden = false;
        } else {
          hideAll();
        }
      };

      const hideAll = () => {
        items.forEach((el) => (el.hidden = true));
        root.hidden = true;
      };

      const showForKeyword = (e) => {
        const kw = (e.detail && e.detail.keyword) || '';
        if (!kw) return hideAll();
        showFor(kw.toLowerCase());
      };

      document.addEventListener('brand-search:matched', showForKeyword);
      document.addEventListener('brand-search:no-match', showForKeyword);
      document.addEventListener('brand-search:cleared', hideAll);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
